import { Component, OnInit, OnDestroy } from '@angular/core';
import { CardItemNonExpandableComponent } from '../card-item-non-expandable/card-item-non-expandable.component';
import { Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'card-item-expandable',
  templateUrl: './card-item-expandable.component.html',
  styleUrls: ['./card-item-expandable.component.scss', '../card-item-non-expandable/card-item-non-expandable.component.scss'],

  standalone: false,
})
export class CardItemExpandableComponent extends CardItemNonExpandableComponent implements OnInit, OnDestroy {
  // Rich text editor for description field
  descriptionEditor: Editor;

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  override ngOnInit(): void {
    super.ngOnInit();
    this.descriptionEditor = new Editor();
  }

  ngOnDestroy(): void {
    this.descriptionEditor?.destroy();
  }
}
